import type { AudioOutputDevice, SpeakerSelectionInput } from './audioDeviceTypes';
import { findStoredDevice } from './findStoredDevice';
import { matchesRecommendedDevice } from './recommendedDevice';

/** A missing stored speaker is no state of its own, because nothing else in the app depends on it. */
export function selectSpeaker(input: SpeakerSelectionInput): AudioOutputDevice | null {
  const { outputs, defaultGroupId, settings } = input;
  return (
    findStoredDevice(outputs, settings.confirmedSpeaker) ??
    outputs.find((output) => matchesRecommendedDevice(output.label)) ??
    outputs.find((output) => output.groupId === defaultGroupId) ??
    outputs[0] ??
    null
  );
}
